/**
 * The signed-out screen, shown by RootLayout whenever there's no session.
 * Normally that's the landing page. When an AI assistant's authorization
 * sent the parent here (`/login` with the OAuth provider's signed query),
 * it's a short sign-in instead, so the parent finishes connecting without a
 * homepage in the way; sign-in then resumes the authorization.
 */
import { SignInButtons } from "../components/sign-in.tsx";
import { LegalLinks } from "../components/legal-links.tsx";
import { isAssistantSignIn } from "../lib/auth-client.ts";
import { Landing } from "./landing.tsx";

export function Login() {
  if (!isAssistantSignIn(window.location)) return <Landing />;
  return (
    // No household data here, so session replays may show its words.
    <div
      data-ph-unmask
      className="mx-auto flex min-h-dvh w-full max-w-[480px] flex-col justify-center px-6 pb-16"
      style={{ paddingTop: "calc(24px + env(safe-area-inset-top))" }}
    >
      <h1 className="heading text-[44px] tracking-[-0.03em]">Babia</h1>
      <div className="head-rule" />
      <p className="mt-6 text-[17px] leading-snug">Connect your AI assistant to your baby log.</p>
      <p className="mt-2 text-[14px] opacity-65">
        Sign in with the Google or Facebook account you use for Babia. Next, you’ll choose whether
        to let your assistant log and read entries for your household.
      </p>
      <SignInButtons className="mt-8" showReturned password />
      <footer className="mt-8 border-t border-divider pt-4">
        <p className="mb-2 text-[13px] opacity-65">
          By continuing, you agree to the Terms of Service. Read our Privacy Policy to learn how
          Babia handles your information.
        </p>
        <LegalLinks />
      </footer>
    </div>
  );
}
